import { LIBRARY_SECTIONS } from "@/shell/navModel";

import { SectionSurface } from "./SectionSurface";

/**
 * The shared Clinical library.
 *
 * Library assets are canonical and shared across projects; a project adopts a
 * pinned version rather than referencing a moving target. #28 serves that
 * model and #32 renders it: each rail section below is a slice of the
 * versioned catalog, with provenance, adoption impact, and the archive-only
 * lifecycle.
 *
 * ## THE PAGE'S OWN HEADER IS GONE (#908)
 *
 * This route used to open with a `PageHeader` — `h1` "Clinical library" over a
 * sentence about pinned adoption — above the rail, on every one of the seven
 * sections. #489 put the product's name there for a good reason (the heading
 * had read "Clinical editor", naming the whole application); #908 removes the
 * banner itself, which is a different question from what it said.
 *
 * The observed gap is that the reference has no such banner. Its library keeps
 * the rail persistent and opens the content area with the SECTION: the
 * breadcrumb `Clinical library / Pathways`, the section's name as the page's
 * only `h1`, its own description, and its creation action at the right of that
 * same row. A banner naming the surface a clinician is already looking at cost
 * a heading level and about 90px of every library screen, and pushed each
 * section's own identity — where it existed at all — down to an `h2`.
 *
 * So the header moved rather than disappearing: `LibrarySectionHeader` renders
 * it per section, and every library body mounts one. #492's `NamedSectionHeader`
 * was the two-catalog stand-in for that and recorded the reconciliation as a
 * later ticket's; it is deleted here, with its `h2` becoming the `h1` it could
 * not be while this banner stood above it.
 */
export function LibraryRoute() {
  return (
    <SectionSurface
      groups={LIBRARY_SECTIONS}
      basePath="/library"
      railLabel="Library sections"
      defaultSlug="pathways"
      emptyHeading="Library assets are versioned and shared across every project."
    />
  );
}
